module.exports = __webpack_public_path__ + "img/Hands.00bfbde1.svg";